import * as _ from 'lodash'
import q from 'q'
import config from 'config'
import { fabric } from 'fabric'
import letterConfig from 'letter/config'
import FabricText from 'letter/model/letter_fabric_text'

const PADDING = 10

const getTextOptions = function getTextOptions(letterElement) {
  return _.assign(
    {
      fontFamily: letterElement.metaData.font,
      fontWeight: letterElement.metaData.fontWeight,
      fill: letterElement.metaData.color,
      color: letterElement.metaData.color,
      fontSize: letterElement.metaData.fontSize,
      fontStyle: letterElement.metaData.italic ? 'italic' : 'normal',
      underline: letterElement.metaData.underline,
      left: parseFloat(letterElement.x),
      top: parseFloat(letterElement.y),
    },
    letterConfig.fabricOptions,
  )
}

const getShapeOptions = function getShapeOptions(letterElement) {
  return _.assign(
    {
      color: letterElement.metaData.color,
      left: parseFloat(letterElement.x),
      top: parseFloat(letterElement.y),
      width: letterElement.metaData.width,
      height: letterElement.metaData.height,
    },
    letterConfig.fabricShapeOptions,
  )
}

const buildText = function buildText(letterElement) {
  const deferred = q.defer()

  const text = new FabricText(letterElement.metaData.html, getTextOptions(letterElement))
  text._letterElementId = letterElement.id
  text._sortId = letterElement.sortId

  deferred.resolve(text)

  return deferred.promise
}

const buildImage = function buildImage(letterElement) {
  const deferred = q.defer()

  const url = `${config.imageResourceHost}${letterElement.metaData.imageUrl}`
  const imageOptions = _.assign({
    left: parseFloat(letterElement.x),
    top: parseFloat(letterElement.y),
  }, letterConfig.fabricOptions)

  fabric.Image.fromURL(url, function(image) {
    if (!image) {
      deferred.reject(`Could not retrieve image from url: ${url}`)
    }
    deferred.resolve(image)
  }, imageOptions)

  return deferred.promise.then((image) => {
    image._letterElementId = letterElement.id
    image._letterPaperImageId = letterElement.letterPaperImageId
    image._sortId = letterElement.sortId
    return image
      .set(imageOptions)
      .scaleToHeight(letterElement.metaData.height + (PADDING * 2))
      .scaleToWidth(letterElement.metaData.width + (PADDING * 2))
      .setCoords()
  })
    .catch((error) => {
      throw new Error(`LetterElements to FabricObjects Utils: ${error}`)
    })
}

const buildShape = function buildShape(letterElement) {
  const shape = new fabric.Rect(getShapeOptions(letterElement))
  shape._letterElementId = letterElement.id
  shape._sortId = letterElement.sortId

  return q(shape)
}

const buildPromises = (letterElementsCollection) => letterElementsCollection?.reduce((fabricObjects, letterElement) => {
  let promise
  switch (letterElement.type) {
    case 'image':
      promise = buildImage(letterElement)
      break
    case 'text':
      promise = buildText(letterElement)
      break
    case 'rectangle':
      promise = buildShape(letterElement)
      break
  }
  fabricObjects.push(promise)
  return fabricObjects
}, [])

export default function letterElementsToFabricObjects(letterElementsCollection) {
  const promises = buildPromises(letterElementsCollection)
  return q.all(promises)
}
